import { PlayerApiError } from '@/scenarios/legacy-player/types/instance';
import { useOnError as useOnPlayerError } from '@/scenarios/legacy-player/hooks/useOnError';

import { PlayerError, AppErrors } from '../../../error-boundary-context/error-map/map';

import { useHandleAndLogError } from './use-handle-and-log-error';
import { playerErrors } from './config';

export const useOnError = (onError?: (error: PlayerApiError) => void) => {
    const onErrorWrapped = useHandleAndLogError<PlayerApiError>({
        onError,
        errorMessage: (error) => playerErrors.internalError(error),
        isFatal: (error) => error.isFatal,
        errorToRaise: (error) => (error.code as AppErrors) ?? PlayerError.Internal,
    });

    useOnPlayerError(onErrorWrapped);
};
